var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56807 1.47655H4.82727V1.69251H5.56807V1.47655Z",
    fill: "#59B974"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99832 1.94429H4.82544V2.16025H5.99832V1.94429Z",
    fill: "#59B974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5671 2.41055H4.82629V2.62652H5.5671V2.41055Z",
    fill: "#59B974"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56624 2.87451H4.82544V3.09047H5.56624V2.87451Z",
    fill: "#59B974"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 3.34482H4.82727V3.56078H6.00015V3.34482Z",
    fill: "#59B974"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56807 3.81024H4.82727V4.0262H5.56807V3.81024Z",
    fill: "#59B974"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5682 4.27667H4.82739V4.49263H5.5682V4.27667Z",
    fill: "#59B974"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99918 4.74384H4.82629V4.9598H5.99918V4.74384Z",
    fill: "#59B974"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56807 5.21065H4.82727V5.42661H5.56807V5.21065Z",
    fill: "#59B974"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56807 5.67908H4.82727V5.89504H5.56807V5.67908Z",
    fill: "#59B974"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99918 6.1436H4.82629V6.35956H5.99918V6.1436Z",
    fill: "#59B974"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97918 10.8162C3.82517 10.8162 4.51098 10.1304 4.51098 9.28445C4.51098 8.43846 3.82517 7.75266 2.97918 7.75266C2.1332 7.75266 1.44739 8.43846 1.44739 9.28445C1.44739 10.1304 2.1332 10.8162 2.97918 10.8162Z",
    fill: "#59B974"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53046 6.73714V1.54979C4.53046 0.695173 3.83518 0 2.98057 0C2.12596 0 1.43068 0.695173 1.43068 1.54979V6.73714C0.545302 7.27718 0 8.24239 0 9.28299C0 10.9265 1.33711 12.2636 2.98057 12.2636C4.62411 12.2636 5.96124 10.9266 5.96124 9.28299C5.96124 8.24239 5.41587 7.27718 4.53046 6.73714ZM2.98057 11.1981C1.92463 11.1981 1.06559 10.339 1.06559 9.28302C1.06559 8.29174 1.82263 7.4741 2.78894 7.37765V1.35741H3.17218V7.37765C4.13849 7.4741 4.89561 8.29174 4.89561 9.28302C4.89563 10.339 4.03654 11.1981 2.98057 11.1981Z",
    fill: "#59B974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/TemperatureIcon.edd51f0680a0fd919ad6e0ff14eb1ab2.svg";
export { ForwardRef as ReactComponent };